import styled from 'styled-components';
import { DateContainerInput, FilterIcon } from './SearchStyles';

/** Card de filtros (Locações e telas que reutilizam SearchGroup). */
export const RequestsFilterCard = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 14px rgba(21, 43, 78, 0.09);
  border: 1px solid rgba(21, 43, 78, 0.08);
  background-image: linear-gradient(
    180deg,
    rgba(21, 43, 78, 0.05) 0%,
    rgba(255, 255, 255, 0) 14px
  );
  /* Padding à direita maior que à esquerda: o TourTooltip (?) fica com offset negativo e precisa de espaço. */
  padding: 14px 22px 14px 16px;
  overflow: visible;
`;

export const RequestsFilterForm = styled.form`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px 14px;
  min-width: 0;
  overflow: visible;
`;

export const RequestsSearchFieldGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 1 300px;
  max-width: 340px;
  min-width: 160px;
`;

export const RequestsDateFieldGroup = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px 10px;
  flex: 1 1 auto;
  min-width: 0;
  box-sizing: border-box;
`;

/** Card + form em coluna (mobile / modal) — busca e datas empilhadas. */
export const RequestsFilterCardMobile = styled(RequestsFilterCard)`
  padding: 14px 16px;
`;

/** Linha única: ícone + De + data + a + data (mobile). */
export const RequestsMobileDateRangeRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px 6px;
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 2px;

  ${FilterIcon} {
    flex-shrink: 0;
  }

  /* Sobrescreve width:100% do DateContainerInput em max-width:500px */
  ${DateContainerInput} {
    width: 86px !important;
    min-width: 72px !important;
    max-width: 100px !important;
    flex-shrink: 0;
  }
`;

export const RequestsFilterFormMobile = styled(RequestsFilterForm)`
  flex-direction: column;
  align-items: stretch;
  flex-wrap: nowrap;
  gap: 14px;

  ${RequestsSearchFieldGroup} {
    flex: 1 1 auto;
    max-width: none;
    width: 100%;
    min-width: 0;
  }

  ${RequestsDateFieldGroup} {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    flex-wrap: nowrap;
    width: 100%;
    min-width: 0;
  }

  ${RequestsDateFieldGroup} button[type='submit'] {
    width: 100%;
    margin-left: 0 !important;
    margin-top: 0;
  }
`;

/** À direita na linha de datas, alinhado verticalmente ao Filtrar. */
export const RequestsFilterInlineActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
  position: relative;
  /* Evita recorte do ícone do TourTooltip (position absolute + right negativo no filho). */
  padding-right: 6px;

  button {
    margin-bottom: 0 !important;
  }
`;
